function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("title", null, "Group 6");

var _ref3 = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  id: "Mobile",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group-6",
  stroke: "#16D089"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Oval-Copy-2",
  strokeWidth: 2.07999992,
  fill: "#F3F0F0",
  cx: 10.7249996,
  cy: 10.7249996,
  r: 9.68499964
}), /*#__PURE__*/React.createElement("g", {
  id: "Group-9-Copy-20",
  transform: "translate(7.150000, 7.800000)",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2.17671992
}, /*#__PURE__*/React.createElement("g", {
  id: "confirm-copy-7"
}, /*#__PURE__*/React.createElement("polyline", {
  id: "Path",
  points: "0 3.11999989 2.99478764 6.23999977 8.31999969 1.41881168e-12"
})))));

var SvgStatusGreen = function SvgStatusGreen(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "0 0 22 22",
    ref: svgRef
  }, props), title === undefined ? _ref2 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref3, _ref4);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgStatusGreen, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/status-green.51d6da47.svg";
export { ForwardRef as ReactComponent };